import { IGizmo } from '../../types';

interface IParams {
  gizmo: IGizmo;
  filter: 'flux.options';
}

/**
 * Filter gizmo configurations depending on the filter
 *
 * @param {IGizmo} gizmo gizmo configuration from where to start the search
 * @param {string} filter filter to apply
 *
 * @returns
 */
function filterGizmoConfigs({ gizmo, filter }: IParams): IGizmo[] {
  let foundGizmos: IGizmo[] = [];

  const childGizmos: IGizmo[] | undefined = gizmo.gizmos;

  if (childGizmos && childGizmos.length > 0) {
    if (filter === 'flux.options') {
      const filteredGizmos = childGizmos.filter(childGizmo => {
        if (
          typeof childGizmo.ops?.display !== 'boolean' &&
          childGizmo.ops?.display?.flux &&
          childGizmo.ops.display.flux.includes('.options')
        ) {
          return true;
        }
        if (
          typeof childGizmo.ops?.editable !== 'boolean' &&
          childGizmo.ops?.editable?.flux &&
          childGizmo.ops.editable.flux.includes('.options')
        ) {
          return true;
        }
        if (
          typeof childGizmo.ops?.required !== 'boolean' &&
          childGizmo.ops?.required?.flux &&
          childGizmo.ops.required.flux.includes('.options')
        ) {
          return true;
        }

        return false;
      });

      if (filterGizmoConfigs.length > 0) {
        foundGizmos.push.apply(foundGizmos, filteredGizmos);
      }

      for (const childGizmo of childGizmos) {
        const foundChildGizmos: IGizmo[] = filterGizmoConfigs({
          gizmo: childGizmo,
          filter,
        });

        if (foundChildGizmos.length > 0) {
          foundGizmos = foundGizmos.concat(foundChildGizmos);
        }
      }
    }
  }

  return foundGizmos;
}

export default filterGizmoConfigs;
